<template>
  <!-- v-model="drawer"
  
      :dark="barColor !== 'rgba(38, 51, 82, 1), rgba(38, 51, 82, 0.9)'"-->
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :mini-variant="true"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
    elevation="2"
    class="ma-0"
    style="z-index: 200"
  >
    <!-- <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, rgba(0, 0, 0, .6), rgba(0, 0, 0, .3)`"
        v-bind="props"
      />
    </template> -->
    <br /><br />
    <!-- {{ activeRoute }} -->
    <v-row>
      <v-col class="ma-0 pa-0">
        <v-list dense nav class="ma-0 pa-0">
          <v-list-item
            class="ma-0 pa-0"
            style="background-color: white:  !important;"
          >
          </v-list-item>
        </v-list>

        <v-list>
          <v-list-item
            v-for="item in publicItems"
            :key="item.to"
            link
            :item="item"
            :to="item.to"
            :class="{ 'primary--text': $route.path === item.to }"
            class="mx-1"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    activeRoute: null,
    imageUrlLogo: "@/assets/img/logoDark.png",
  }),
  created() {},

  mounted() {
    this.$forceUpdate();
  },

  watch: {
    $route(to, from) {
      this.activeRoute = to.path; // Update the active route when route changes
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    modeHomolg() {
      return `${process.env.VUE_APP_ENV}` == "HOMOLOG";
    },

    ...mapState(["barColor", "barImage"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    images: function () {
      var images = this.$session.get("images");
      if (images) return images;
      else
        return {
          logo: "https://mxwqlouaaupkgunfdbku.supabase.co/storage/v1/object/public/test/logoNewStMarie-removebg.png",
          logoWhite:
            "https://mxwqlouaaupkgunfdbku.supabase.co/storage/v1/object/public/test/logoNewStMarie-removebg.png",
        };
    },
    items: function () {
      var items = [];
      return items;
    },
    publicItems: function () {
      var publicItems = [];
      publicItems.push({
        icon: "mdi-send",
        title: "Envios",
        to: "/installments",
      });

      publicItems.push({
        icon: "mdi-monitor",
        title: "Histórico de notas",
        to: "/offers",
      });
      publicItems.push({
        icon: "mdi-monitor",
        title: "Histórico de envios",
        to: "/acquisitions",
      });

      publicItems.push({
        icon: "mdi-file-edit-outline",
        title: "Cartas de correção",
        to: "/offers-updates",
      });

      publicItems.push({
        icon: "mdi-file-upload",
        title: "Upload manual de XML",
        to: "/xml-import",
      });
      return publicItems;
    },
  },

  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      };
    },
  },
};
</script>
<style></style>
